import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'clsx';

import { Skeleton } from '@/mui/components';

import styles from './Slide.module.scss';

function SlideSkeleton(props) {
  return (
    <div className={classNames(styles.Slide, styles.Slide___plug)}>
      <Skeleton variant="rectangular" width="100%" height={props.height} className={styles.SlideContainer} />
      <div className={styles.SlideTitle}>&nbsp;</div>
    </div>
  );
}

SlideSkeleton.propTypes = {
  height: PropTypes.number.isRequired,
};

export default SlideSkeleton;
